import { Link } from "@tanstack/react-router";
import { ActionIcon } from "@/components/tools/action-icon";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { actions } from "@/lib/tools/catalog";

export default function Header() {
  return (
    <nav className="isolate w-full border-b bg-background py-2">
      <div className="container flex items-center">
        <Link to="/" className="font-display text-2xl font-medium italic leading-none text-primary">
          pdfisfun
        </Link>
        <NavigationMenu className="flex-grow px-4 max-md:px-8">
          <NavigationMenuList>
            <NavigationMenuItem>
              <NavigationMenuTrigger>Tools</NavigationMenuTrigger>
              <NavigationMenuContent>
                <div className="grid w-[250px] gap-3 p-4 md:w-[500px] md:grid-cols-2 lg:w-[600px]">
                  {actions
                    .filter((action) => !action.upcoming)
                    .map((action) => (
                      <NavigationMenuLink
                        key={action.link.url}
                        href={action.link.url}
                        className="flex select-none items-center gap-2 space-y-1 rounded-md px-3 py-2 leading-none no-underline outline-none transition-colors hover:bg-accent hover:bg-opacity-50 hover:text-primary focus:bg-accent focus:text-accent-foreground md:px-4"
                      >
                        <ActionIcon id={action.id} />
                        {action.title}
                      </NavigationMenuLink>
                    ))}
                </div>
              </NavigationMenuContent>
            </NavigationMenuItem>
          </NavigationMenuList>
        </NavigationMenu>
      </div>
    </nav>
  );
}
